module.exports = __webpack_public_path__ + "img/dispute.0c9f1fe4.svg";